<template>
  <div class="substep-review-screenshots">
    <div class="substep-header">
      <h3 data-testId="step-title">Review screenshots</h3>
      <p>See your members' activity levels along with screenshots of what they're working on.</p>
    </div>
    <div class="select-team-member">
      <AppSelect
        v-model="teamMember"
        has-tooltip
        :options="teamMembers"
        tooltip-title="Select a team member to review their screenshots"
        :select2-options="{ placeholder: 'Team member' }"
        @input="onTeamMemberChange"
      />
    </div>

    <div class="substep-body">
      <div
        v-if="!teamMember"
        class="card-image"
      >
        <img
          :src="getImageAsset('no_team_member_selected').src"
          :alt="getImageAsset('no_team_member_selected').alt"
        />
        <p>No team member selected</p>
      </div>
      <div
        v-if="showActivities"
        id="activities"
        class="mt-30"
      >
        <ActivitiesHourRow
          v-for="hour in teamMemberHours"
          :key="hour.starts_at"
          :hour="hour"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import { ACTIVITIES_SCREENSHOT_PENDING_ORIGINAL } from '~/rails_assets';
import ActivitiesHourRow from './components/review_screenshots/ActivitiesHourRow.vue';

export default {
  name: 'ReviewScreenshots',
  components: { ActivitiesHourRow },
  mixins: [GettingStartedMixin],
  props: {
    teamMemberActivities: {
      type: Object,
      default: () => {},
      validator: (teamMemberActivities) => {
        return Object.values(teamMemberActivities).every((teamMember) => {
          return Array.isArray(teamMember) && teamMember.every((hour) => {
            return typeof hour.starts_at === 'string' && Array.isArray(hour.activities);
          });
        });
      },
    },
    teamMembers: {
      type: Array,
      default: () => [],
      validator: (teamMembers) => {
        return teamMembers.every((teamMember) => {
          return typeof teamMember.id === 'number' && typeof teamMember.text === 'string';
        });
      },
    },
  },
  data: () => ({
    intersectionObserver: null,
    teamMember: null,
    teamMemberHours: null,
    approvedTimesheets: [],
    showGalleryDialog: false,
    showScreenshot: false,
    selectedRow: null,
    ACTIVITIES_SCREENSHOT_PENDING_ORIGINAL,
  }),
  computed: {
    showActivities() {
      return !!this.teamMember;
    },
  },
  methods: {
    onTeamMemberChange() {
      this.teamMemberHours = this.teamMemberActivities[this.teamMember];
      this.$emit('completeSubstep');
    },
  },
};
</script>
